export default __webpack_public_path__ + "static/Plots0025-a2d11f256bc069a5df67419765b3a92f.jpg";